"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const HashtagIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M6.141.01a1 1 0 01.849 1.132L6.58 4h3.98l.45-3.14a1 1 0 111.98.283L12.58 4H15a1 1 0 010 2h-2.704l-.572 4H14a1 1 0 010 2h-2.561l-.45 3.141a1 1 0 11-1.98-.283L9.42 12H5.44l-.45 3.141a1 1 0 01-1.979-.283L3.418 12H1a1 1 0 110-2h2.704l.571-4H2a1 1 0 110-2h2.561L5.01.86A1 1 0 016.141.01zM6.296 6l-.572 4h3.98l.571-4h-3.98z",
    clipRule: "evenodd"
  })))
});
HashtagIcon.displayName = 'HashtagIcon';
var _default = exports.default = HashtagIcon;